"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const PageHelper_1 = require("@react/web/SubscriptionOfferDetail/PageHelper/PageHelper");
const OfferInquiryButton = ({ offer, gtmInquiryTypeEnum, }) => react_1.default.createElement("a", { href: PageHelper_1.PageHelper.getOfferInquiryUrl(offer), className: `button button-primary ${gtmInquiryTypeEnum !== 'sticky-panel'
        ? 'button-big' : ''} gtm-car-offer-detail-${gtmInquiryTypeEnum}-inquiry-button`, title: "Nez\u00E1vazn\u011B poptat", rel: "nofollow" }, "Nez\u00E1vazn\u011B poptat");
exports.default = OfferInquiryButton;
